import React, { useContext, useEffect, useState } from 'react'
import { TestContext } from '../../../utils/context'
import styles from '../styles.module.scss'
import { getQuestionsFile } from '../../../actions/testing'
import { useDispatch, useSelector } from 'react-redux'
import { openCarousel } from '../../../actions/carousel'
import Loader from "react-loader";
import { createNotification } from '../../notifications/notifications'


const TextQuestion = ({visible, question, setQuestionPassed}) => {
  
  const {addQuestionAnswer, nextQuestion, closeTestHandler, testId, navPanel, finishTest, timeOver} = useContext(TestContext)

  const dispatch = useDispatch()
  const {data: filesData, loading} = useSelector(state => state.testing.files)
  useEffect(() => {
    const filesRequested = filesData.hasOwnProperty(question.question_id)
    if (question.question_id && visible && !filesRequested) dispatch(getQuestionsFile(question.question_id))
  }, [visible])

  const [answer, setAnswer] = useState('')

  useEffect(() => {
    !timeOver && setAnswer('')
  }, [timeOver])

  const files = filesData[question.question_id]

  const sendAnswerHandler = async () => {
    if (!answer.trim()) return createNotification('error', 'Введите ответ')
    const payload = [{ answer_text: answer }]
    const success = await addQuestionAnswer(testId, question.question_id, payload)
    if (!success) return;
    setQuestionPassed()
    nextQuestion()
  }

  const renderFile = (file, ind) => (
    <img
      onClick={openCarouselHandler(ind)}
      type={file?.mime}
      src={`data:image/jpeg;base64,${file?.content}`}
      key={file?.name}
      alt={file?.name}
    />
  )

  const openCarouselHandler = (initialSlide) => () => {
    const images = files.map(file => `data:image/jpeg;base64,${file.content}`)
    dispatch(openCarousel({images, initialSlide}))
  }

  return (
    <div style={{display: visible ? 'block' : 'none'}}>
      <div className={styles.textQuestion}>
        <p className={styles.taskTitle}>{question.question_text}</p>
        <div className={styles.files}>
          {
            loading
              ? <Loader/>
              : !!files?.length && files.map(renderFile)
          }
        </div>
        <textarea
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
        />
      </div>
      {navPanel}
      <div className={styles.buttonsBlock}>
        <button onClick={sendAnswerHandler}>Ответить</button>
        <button onClick={finishTest}>Завершить</button>
      </div>
    </div>
  )
}

export default TextQuestion